import { useState } from "react";
import { useAdminLogin } from "./useAdminLogin";
import { Circles } from 'react-loader-spinner'


const AdminLogin = () => {

    const [email,setEmail] = useState('');
    const [password,setPassword] = useState('');
    const {adminLogin, error, isLoading} = useAdminLogin();
    
    const handleSubmit = async (e) => {

        e.preventDefault();
        await adminLogin(email,password);
    }
    
    return (
        <main className="form-signin">
            
             <div className="px-4 py-5 text-center" onSubmit={handleSubmit}>
             {error && <div className="error-message">{error}</div>}
                <form>
                    <h1 className="h3 mb-3 fw-normal">Admin Login</h1>

                    <div className="form-floating ">
                        <input 
                        type="email" 
                        className="form-control" 
                        id="floatingInput" 
                        value={email}
                        onChange={(element) => setEmail(element.target.value)}
                        />
                        <label htmlFor="floatingInput">Email</label>
                    </div>
                    <div className="form-floating">
                    <input 
                        type="password" 
                        className="form-control" 
                        id="floatingPassword" 
                        placeholder="Password"
                        value={password}
                        onChange={(element) => setPassword(element.target.value)}
                    />
                    <label htmlFor="floatingPassword">Password</label>
                    </div>   

                      <Circles
                    height="80"
                    width="80"
                    color="#4A90E2"
                    ariaLabel="circles-loading"
                    wrapperStyle={{justifyContent: "center",
                    alignItems: "center",}}
                    wrapperClass=""
                    visible={isLoading}
                    />               
                    <button disabled={isLoading}  className="w-100 btn btn-lg btn-primary" type="submit">Sign in</button>
                </form>
             </div>
           
        </main>

    )
}


export default AdminLogin;